module.exports = __webpack_public_path__ + "static/media/ageelementbrighteningeyecontour.2b5e8a7f.png";